import React, { useEffect, useState } from 'react';
import io from "socket.io-client";
import { useSelector } from 'react-redux';

import './ChatContainer.css';
import ChatBox from './ChatBox';
import { ChatState } from '../../context/ChatProvider';

const ENDPOINT = "https://be-tripaider.onrender.com"; // "https://talk-a-tive.herokuapp.com"; -> After deployment
var socket, selectedChatCompare;

function ChatContainer() {
  const isAuthenticated = useSelector((state) => state?.auth?.isAuthenticated);
  const [socketConnected, setSocketConnected] = useState(false);
  const { selectedChat, setSelectedChat, user, notification, setNotification } =
    ChatState();

  useEffect(() => {
    socket = io(ENDPOINT);
    socket.emit("setup", user);
    socket.on("connected", () => setSocketConnected(true));
    // socket.on("typing", () => setIsTyping(true));
    // socket.on("stop typing", () => setIsTyping(false));

    // eslint-disable-next-line
  }, [user]);

  return isAuthenticated ? <ChatBox socketConnected={socketConnected} /> : null;
}

export default ChatContainer;
